module.exports = __webpack_public_path__ + "static/img/038百家诚信企业活动官网.34fc4be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/038百家诚信企业活动官网.jpg
// module id = XMZp
// module chunks = 0